import TeamComponent, {
  TeamComponentProps
} from 'components/marketingSite/team/TeamComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import WPService from 'services/wp.service';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type TeamPageProps = TeamComponentProps & WithBaseUrl;

const TeamPage: React.FC<TeamPageProps> = ({ team, baseUrl }) => {
  const { t } = useI18n('web');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('team.title')}
        url={APP_URLS.team}
        desc={t('team.description')}
        imgUrl={`${baseUrl}${getPublicPath('/images/cards/card_team.png')}`}
        indexable={true}
      />
      <TeamComponent team={team} />
    </>
  );
};

export default TeamPage;

type WPTeamMember = {
  namePersonBannerTeam: string;
  descriptionPersonBannerTeam: string;
  linkPostPersonBannerTeam: string;
  rrssPersonBannerTeam: {
    linkTwitterRrssPersonBannerTeam: string;
    linkLinkedinRrssPersonBannerTeam: string;
  };
  photoPersonBannerTeamURL: string;
};

export const getStaticProps: GetStaticProps<TeamPageProps> = async ({
  locale
}) => {
  const allTeam = (await WPService.getTeam()).personsBannerTeam || [];

  const teamData = allTeam.map((t: WPTeamMember) => {
    const segments = t.linkPostPersonBannerTeam?.split('/');
    const last = segments.pop() || segments.pop();

    return {
      name: t.namePersonBannerTeam,
      img: t.photoPersonBannerTeamURL,
      desc: {
        ES: t.descriptionPersonBannerTeam
      },
      twitter: t.rrssPersonBannerTeam?.linkTwitterRrssPersonBannerTeam || null,
      linkedin:
        t.rrssPersonBannerTeam?.linkLinkedinRrssPersonBannerTeam || null,
      url: last || null
    };
  });

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'web'
      ])),
      team: teamData,
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
